import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=bd36fafe&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd36fafe')) {
      api.createRecord('bd36fafe', component.options)
    } else {
      api.reload('bd36fafe', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=bd36fafe&", function () {
      api.rerender('bd36fafe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bopLGgPRloRQ/JS/imageCarousel.vue"
export default component.exports